import {
  MIN_IMAGE_SIZE_IN_BYTES,
  MAX_IMAGE_SIZE_IN_BYTES,
  ALLOWED_IMAGE_MIME_TYPES,
} from '@okletsplay/core';

export const UPPY_IMAGE_OPTIONS = {
  restrictions: {
    maxNumberOfFiles: 1,
    allowedFileTypes: ALLOWED_IMAGE_MIME_TYPES,
    minFileSize: MIN_IMAGE_SIZE_IN_BYTES,
    maxFileSize: MAX_IMAGE_SIZE_IN_BYTES,
    maxTotalFileSize: MAX_IMAGE_SIZE_IN_BYTES,
  },
  allowMultipleUploads: false,
};
